export default "__VITE_ASSET__BKOcTOlL__"